module.exports = __webpack_public_path__ + "static/media/madame.6d56ca3b.svg";